
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code7 } from "@/views/resources/documentation/element-ui/basic/space/code";

export default defineComponent({
  name: "alignment",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code7
    };
  }
});
